import React from "react";

/**
 * The editor's action footer: the status messages the form already showed,
 * plus cancel and the single submit.
 *
 * Both captions and the disabled/submitting wording are the ones the form
 * used before — the L0 net drives the edit flow through
 * "Änderungen speichern" and reads cancel by its exact name.
 *
 * Cancel keeps calling the existing `handleCancelEdit`; it resets the form
 * fields and leaves the workspace open, exactly as it did (discovery risk
 * R14 is deliberately not fixed here). There is no second dismiss control.
 */
export default function ListingEditorActions({
  editingListingId,
  submitting,
  createSuccess,
  createError,
  onCancelEdit,
}) {
  const submitLabel = submitting
    ? (editingListingId ? "Wird gespeichert…" : "Wird erstellt…")
    : (editingListingId ? "Änderungen speichern" : "Listing erstellen");

  return (
    <div className="mt-6 border-t border-border pt-4">
      {createSuccess ? (
        <p className="m-0 mb-3 rounded-lg border border-sky-500/20 bg-sky-500/5 px-3 py-2.5 text-sm text-sky-700 dark:text-sky-400">
          {createSuccess}
        </p>
      ) : null}
      {createError ? (
        <p className="m-0 mb-3 text-sm text-rose-500">{createError}</p>
      ) : null}

      <div className="flex flex-wrap items-center justify-between gap-3">
        <button
          type="button"
          onClick={onCancelEdit}
          disabled={submitting}
          className="rounded-lg border border-border px-4 py-2 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-70"
        >
          Abbrechen
        </button>
        <button
          type="submit"
          disabled={submitting}
          className="rounded-lg bg-gradient-to-r from-[#5b8cff] to-[#7c5cfc] px-5 py-2 text-sm font-semibold text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-70"
        >
          {submitLabel}
        </button>
      </div>
    </div>
  );
}
